module.exports = __webpack_public_path__ + "static/media/sleepygray_crop.9c13b779.jpg";